import axiosInstance from ".";

export const uploadImage = (payload) => {
  const { file } = payload;
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post("/file/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getFileUrl = async (params) => {
  return axiosInstance.get("/file/file-url", { params });
};